import { Dispatch, createContext } from 'react'

type CashContextProps = {
  isCash: boolean
  setIsCash: Dispatch<React.SetStateAction<boolean>>
}

const CashContext = createContext<CashContextProps>({
  isCash: false,
  setIsCash: () => null,
})

export default CashContext
